import React, { useEffect, useRef, useState } from "react";
import Layout from "../../components/user/Layout";

import { GrUnorderedList } from "react-icons/gr";
import { LuIdCard, LuBell, LuKeyRound } from "react-icons/lu";
import { FaDartLang } from "react-icons/fa6";
import {
  DOWNLOAD_FORM_MEMBER_ROUTE,
  ID_ROUTE,
  MEMBER_PROFILE_ROUTE,
  PASSWORD_ROUTE,
  PAYMENT_WALLET_ROUTE,
} from "../../routes/web/rootRoutes";

import { useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import authManager from "../../utils/authManager";
import ShowFormCards from "../../components/web/form/ShowFormCards";
import { getFileUrl } from "../../utils/helper";
import { FaWallet } from "react-icons/fa";

function Dashboard() {
  const navigate = useNavigate();
  const user = authManager.getUserProfile();

  const handleCardClick = (link) => {
    navigate(link);
  };

  const menuCards = [

    {
      title: "Personal Profile",
      description: "View and manage your profile",
      icon: <FaDartLang className="text-2xl" />,
      link: MEMBER_PROFILE_ROUTE,
      gradient: "from-blue-500 to-cyan-500",
      bgGradient: "from-blue-50 to-cyan-50",
    },
    {
      title: "Membership ID",
      description: "View your membership details",
      icon: <LuIdCard className="text-2xl" />,
      link: ID_ROUTE,
      gradient: "from-purple-500 to-pink-500",
      bgGradient: "from-purple-50 to-pink-50",
    },
    {
      title: "Forms & Applications",
      description: "Apply and manage forms",
      icon: <GrUnorderedList className="text-2xl" />,
      link: DOWNLOAD_FORM_MEMBER_ROUTE,
      gradient: "from-orange-500 to-red-500",
      bgGradient: "from-orange-50 to-red-50",
    },
         {
    title: "Renew Your MemberShip",
    description: "Check your payment history & dues",
    icon: <FaWallet className="text-2xl" />,
    link: PAYMENT_WALLET_ROUTE,  
    gradient: "from-amber-500 to-yellow-500",
    bgGradient: "from-amber-50 to-yellow-50",
  },
    {
      title: "Notifications",
      description: "View alerts and updates",
      icon: <LuBell className="text-2xl" />,
      link: "/notifications",
      gradient: "from-green-500 to-emerald-500",
      bgGradient: "from-green-50 to-emerald-50",
    },
    {
      title: "Change Password",
      description: "Update your password",
      icon: <LuKeyRound className="text-2xl" />,
      link: PASSWORD_ROUTE,
      gradient: "from-indigo-500 to-blue-500",
      bgGradient: "from-indigo-50 to-blue-50",
    },
  ];

  return (
    <Layout>
      <div className="mb-b text-center flex  justify-center">

        {user?.image ? (
          <img
            src={getFileUrl(user?.image, 'members')}
            alt="Profile"
            className="w-32 h-32 rounded-2xl object-cover border-4 border-white shadow-xl ring-4 ring-white/50"
          />
        ) : (
          <div className="w-32 h-32 rounded-2xl bg-gradient-to-br from-blue-500 to-indigo-600 text-white flex items-center justify-center text-5xl font-bold border-4 border-white shadow-xl ring-4 ring-blue-100">
            {user?.name?.charAt(0) || 'U'}
          </div>
        )}


      </div>
      <h1 className="text-3xl text-center font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent mb-1">
        <p><span className="capitalize">{user?.name}</span></p>

      </h1>
      <p className="px-3 rounded-md text-center py-1 bg-green-200 text-green-500 font-semibold">Active</p>

      <hr />
      <br />
      <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {menuCards.map((card, index) => (
          <div
            key={index}
            onClick={() => handleCardClick(card.link)}
            className="group relative cursor-pointer"
          >
            <div
              className={`relative overflow-hidden bg-gradient-to-br ${card.bgGradient} rounded-xl border
                border-gray-200 hover:border-transparent transition-all duration-300 hover:shadow-lg hover:scale-105`}
            >
              <div
                className={`absolute inset-0 bg-gradient-to-br ${card.gradient} opacity-0 group-hover:opacity-10
                    transition-opacity duration-300`}
              ></div>

              <div className="relative p-5">
                <div
                  className={`inline-flex items-center justify-center w-14 h-14 rounded-xl bg-gradient-to-br
                        ${card.gradient} text-white mb-3 shadow-md group-hover:shadow-lg transform group-hover:scale-110
                        transition-all duration-300`}
                >
                  {card.icon}
                </div>

                <h3
                  className="text-xl font-semibold text-gray-800 mb-1 group-hover:text-transparent group-hover:bg-gradient-to-r group-hover:bg-clip-text group-hover:from-blue-600 group-hover:to-purple-600 transition-all duration-300"
                >
                  {card.title}
                </h3>
                <p className="text-gray-600 text-sm">{card.description}</p>

                <div className="mt-3 flex items-center text-gray-400 group-hover:text-blue-600 transition-colors duration-300">
                  <span className="text-xs font-medium mr-1">Go</span>
                  <svg
                    className="w-4 h-4 transform group-hover:translate-x-1 transition-transform duration-300"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M17 8l4 4m0 0l-4 4m4-4H3"
                    />
                  </svg>
                </div>
              </div>

              <div
                className={`absolute -bottom-2 -right-2 w-16 h-16 bg-gradient-to-br ${card.gradient} rounded-full
                    opacity-10 group-hover:opacity-20 transition-opacity duration-300 blur-xl`}
              ></div>
            </div>
          </div>
        ))}

        <div
          onClick={() => {
            localStorage.clear();
            navigate("/");
          }}
          className="group relative cursor-pointer"
        >
          <div
            className="relative overflow-hidden bg-gradient-to-br from-pink-50 to-orange-50 rounded-xl border
              border-gray-200 hover:border-transparent transition-all duration-300 hover:shadow-lg hover:scale-105"
          >
            <div
              className="absolute inset-0 bg-gradient-to-br from-orange-500 to-pink-500 opacity-0
                group-hover:opacity-10 transition-opacity duration-300"
            ></div>

            <div className="relative p-5">
              <div
                className="inline-flex items-center justify-center w-14 h-14 rounded-xl bg-gradient-to-br
                    from-orange-500 to-pink-500 text-white mb-3 shadow-md group-hover:shadow-lg transform
                    group-hover:scale-110 transition-all duration-300"
              >
                <LogOut className="text-2xl" />
              </div>

              <h3 className="text-xl font-semibold text-gray-800 mb-1">Logout</h3>
              <p className="text-gray-600 text-sm">Logout your account</p>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-5">
        <ShowFormCards />
      </div>
    </Layout>
  );
}

export default Dashboard;
